import React, { Component } from 'react' 
import { withTranslation } from 'react-i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import queryString from 'query-string';
import { getResult } from "../../utilities/FrontFunctions/AoxFrontFunctions";

class PageUpdateEmailConfirm extends Component {
	constructor(props) {
		super(props)
		this.state = {
			apiResult:[],
		}
	}

	componentDidMount() { 
        var oParams = queryString.parse(window.location.search);
        if(oParams.encOldEmail === undefined && oParams.encNewEmail === undefined){
            this.setState({ apiDatas: { Error:true, Message:"Paramètres manquants." } })
        } else {
            getResult(`/apiaox/Call/InfosPerso_Email_Confirm?encOldMail=${encodeURIComponent(oParams.encOldEmail)}&sEncNewMail=${encodeURIComponent(oParams.encNewEmail)}`)
            .then((apiResult) => { 
                this.setState({ apiResult:apiResult })
            })
        }
	}

	render() {
		const apiResult = this.state.apiResult;

		return (
			<section className="section_form">
				<div className="str_container">
					<div className="ctn_top">
						<h1>{this.props.t("Register_NouveauEmail")}</h1>
                    </div>

                    <div className="ctn_form">
                        <form >
                            {apiResult?.IsValid ?
                                <p>
                                    Votre adresse mail a été mise à jour.<br/>
                                    Vous pouvez à présent vous reconnecter.
                                </p>
                            : 
                                <p className="t_error">
                                    {apiResult?.Message ? apiResult.Message : "Une erreur est survenue."}
                                </p>
                            }
                            <br/>
                            <p className="ctn_cta">
                                <a className="obj_cta" href="/">Retour</a>
                            </p>
                        </form>
                    </div>
				</div>
			</section>
		)
	}
}
 
export default withTranslation()(withSitecoreContext()(PageUpdateEmailConfirm));